// extracted by mini-css-extract-plugin
module.exports = {"root":"LaB1T9","min":"W63p1h","max":"Mq0NhC","button":"SAXZq6"};